import Home from "../src/home/Home";
import { GetStaticProps } from "next";
import { homeUseCase } from "../src/lib/dependencies";

export default function Landing(props) {
  return <Home {...props}></Home>;
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      ...homeUseCase.getCategories(),
      ...homeUseCase.getPopularActivities(),
    },
  };
};
